import logoMark from '../assets/brand/logo.png';

interface LogoProps {
  size?: number;
  className?: string;
  /** Rounds the square source art into a soft badge; disable where the shield shape should stand alone. */
  rounded?: boolean;
}

/**
 * PermitGuard AI brand mark. Backed by the official logo artwork
 * (navy shield / refinery silhouette / hazard-triangle), supplied as the
 * canonical PNG used for the app icons and manifest. Always render at a
 * fixed square size so the source art (512x512) scales cleanly.
 */
export function Logo({ size = 24, className, rounded = true }: LogoProps) {
  return (
    <img
      src={logoMark}
      alt="PermitGuard AI"
      width={size}
      height={size}
      className={className}
      style={{ borderRadius: rounded ? size * 0.22 : 0, display: 'block', flexShrink: 0 }}
    />
  );
}
